type ActiveReservationLike = {
    id: number;
    checkIn?: Date;
    checkOut?: Date;
} | null;

const STORE_PUBLIC_MAX_DATE = new Date(2026, 11, 4, 23, 59, 59, 999);

export const STORE_RESERVATION_REQUIRED_MESSAGE =
    'Após 04/12/2026, compras da Store só são liberadas com link de reserva válido.';
export const STORE_RESERVATION_WINDOW_MESSAGE =
    'Com link de reserva, compras só podem ser feitas entre check-in e check-out.';

export const isStoreOpenByDate = (date: Date = new Date()): boolean => {
    return date.getTime() <= STORE_PUBLIC_MAX_DATE.getTime();
};

export const canAccessStore = ({
    now = new Date(),
    activeReservation,
}: {
    now?: Date;
    activeReservation: ActiveReservationLike;
}): boolean => {
    return Boolean(activeReservation) || isStoreOpenByDate(now);
};

export const canPurchaseStoreDate = ({
    purchaseDate,
    activeReservation,
}: {
    purchaseDate: Date;
    activeReservation: ActiveReservationLike;
}): boolean => {
    if (activeReservation?.checkIn && activeReservation?.checkOut) {
        const purchase = new Date(purchaseDate);
        purchase.setHours(0, 0, 0, 0);

        const checkIn = new Date(activeReservation.checkIn);
        checkIn.setHours(0, 0, 0, 0);

        const checkOut = new Date(activeReservation.checkOut);
        checkOut.setHours(23, 59, 59, 999);

        return purchase.getTime() >= checkIn.getTime() &&
            purchase.getTime() <= checkOut.getTime();
    }

    return isStoreOpenByDate(purchaseDate);
};

export const getStorePublicMaxDate = (): Date => new Date(STORE_PUBLIC_MAX_DATE);
